/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, June 2022
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { scroller } from "react-scroll";
import Select from 'react-select';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { DecisionContainer } from '../../../containers';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { getDistrictForUser, replaceMultipleSpaces } from '../../../lib/utils';
import { PanelStyle } from '../../../constants';
import v from '../../eservices/validators';
import ModalAlert from '../../eservices/ModalAlert';
import styles from './ServiceCreator.css';
import GrayPanel from '../../../components/GrayPanel/GrayPanel';

const {
  leftCol,
  labelCol,
  inputCol,
  inputColExpanded,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
  type,
} = PanelStyle;

const btnStyle = {
  width: '100%',
};

const yesLabel = 'TAK';
const noLabel = 'NIE';

const requiresUserInfo = [
  {
    label: yesLabel,
    value: true,
    state: 'requiresUserInfo',
  },
  {
    label: noLabel,
    value: false,
    state: 'requiresUserInfo',
  },
];

const requiresMap = [
  {
    label: yesLabel,
    value: true,
    state: 'requiresMap',
  },
  {
    label: noLabel,
    value: false,
    state: 'requiresMap',
  },
];

const isEnabled = [
  {
    label: yesLabel,
    value: true,
    state: 'isEnabled',
  },
  {
    label: noLabel,
    value: false,
    state: 'isEnabled',
  },
];

const basicDict = {
  title: {
    label: 'Tytuł',
    editable: true,
  },
  description: {
    label: 'Opis usługi (niewymagane)',
    editable: true,
  },
  requiresUserInfo: {
    label: 'Czy usługa wymaga logowania?',
    editable: true,
    options: requiresUserInfo,
    type: 'Select',

  },
  isEnabled: {
    label: 'Czy usługa jest włączona do widoku publicznego?',
    editable: true,
    options: isEnabled,
    type: 'Select',

  },
  requiresMap: {
    label: 'Czy usługa wymaga wyboru działki/działek?',
    editable: true,
    options: requiresMap,
    type: 'Select',
  },
  mapDescription: {
    label: 'Dodatkowy opis do panelu wyboru działki/działek (niewymagane)',
    editable: true,
    type: 'textarea',
  },
  cost: {
    label: 'Koszt usługi (w przypadku bezpłatnej wpisać 0.00)',
    editable: true,
  },
};

const basicDict2 = {
  title: {
    label: 'Tytuł',
    editable: true,
  },
  description: {
    label: 'Opis usługi (niewymagane)',
    editable: true,
  },
  requiresUserInfo: {
    label: 'Czy usługa wymaga logowania?',
    editable: true,
    options: requiresUserInfo,
    type: 'Select',

  },
  isEnabled: {
    label: 'Czy usługa jest włączona do widoku publicznego?',
    editable: true,
    options: isEnabled,
    type: 'Select',

  },
  requiresMap: {
    label: 'Czy usługa wymaga wyboru działki/działek?',
    editable: true,
    options: requiresMap,
    type: 'Select',
  },
  mapDescription: {
    label: 'Dodatkowy opis do panelu wyboru działki/działek (niewymagane)',
    editable: true,
    type: 'textarea',
  },
};

const addPanel = [
  {
    label: yesLabel,
    value: true,
    state: 'addPanel',
  },
  {
    label: noLabel,
    value: false,
    state: 'addPanel',
  },
];

const attachmentsRequired = [
  {
    label: yesLabel,
    value: true,
    state: 'attachmentsRequired',
  },
  {
    label: noLabel,
    value: false,
    state: 'attachmentsRequired',
  },
];

const attachmentsDict = {
  addPanel: {
    label: 'Czy dodać panel załączników?',
    editable: true,
    options: addPanel,
    type: 'Select',
  },
  attachmentsRequired: {
    label: 'Czy dodanie załączników jest obowiązkowe?',
    editable: true,
    options: attachmentsRequired,
    type: 'Select',
  },
  maxSizeMB: {
    label: 'Maksymalny rozmiar załączników [MB](limit - 70 MB)',
    editable: true,
  },
  additionalText: {
    label: 'Dodatkowy opis',
    editable: true,
    type: 'textarea',
  },
};

const fieldTypes = [
  {
    label: 'Pole tekstowe',
    value: 'textarea',
    state: 'type',
  },
  {
    label: 'Pole numeryczne',
    value: 'number',
    state: 'type',
  },
  {
    label: 'Pole data',
    value: 'Date',
    state: 'type',
  },
  {
    label: 'Pole TAK/NIE',
    value: 'YesNo',
    state: 'type',
  },
  {
    label: 'Pole wyboru',
    value: 'Select',
    state: 'type',
  },
];

const requiredFieldOptions = [
  {
    label: yesLabel,
    value: yesLabel,
    state: 'required',
  },
  {
    label: noLabel,
    value: noLabel,
    state: 'required',
  },
  
];

const defBasic = {
  title: null,
  description: null,
  requiresUserInfo: true,
  requiresMap: true,
  mapDescription: '',
  isEnabled: true,
  cost: '0.00',
};

const defSections = [
  {
    sectionTitle: null,
    additionalText: null,
    fields: [
      {
        fieldTitle: null,
        type: null,
        options: [{ optionValue: null }],
        required: yesLabel,
      }
    ]
  }
];
const maxAttachmentsSize = 70.00
const defAttachments = {
  addPanel: false,
  attachmentsRequired: false,
  maxSizeMB: maxAttachmentsSize,
  additionalText: '',
  formatDocx: false,
  formatJpg: false,
  formatPdf: false,
  formatZip: false,
};

const operationErrorTitle = 'Nie można wykonać operacji.';
const operationErrorMessage = 'Przed wykonaniem operacji należy zakończyć edycję e-usługi. Zapisz lub anuluj zmiany i spróbuj ponownie.';

const templateTestingErrorText = 'Wybrany szablon wniosku jest niepoprawny. Sprawdź poprawność wprowadzonych kluczy, popraw błędy i spróbuj ponownie.';
const templateTestingErrorTitle = 'Błędny szablon wniosku.';

const disabledTitle = 'Nie można wykonać czynności - trwa edycja e-usługi.\nZapisz zmiany i spróbuj ponownie.';
const enabledAddFileTitle = 'Kliknij, aby dodać plik.';
const disabledUploadTitle = 'Nie można wykonać czynności - nie dodano pliku.';
const enabledGoToEservice = 'Kliknij, aby przejść do podglądu e-usługi.';

const marginBottom = '50px'

const MODE_TYPES = {
  CREATE: 'create',
  EDIT: 'edit',
}

const TEMPLATE_TYPES = {
  DOCX: 'docx',
  XML: 'xml',
}

class ServiceCreator extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  state = {
    mode: '',
    shortName: null,
    selected_district: null,
    basicInfo: {
      title: null,
      description: null,
      requiresUserInfo: true,
      requiresMap: true,
      mapDescription: '',
      isEnabled: true,
      cost: '0.00',
    },
    sections: [
      {
        sectionTitle: null,
        additionalText: null,
        fields: [
          {
            fieldTitle: null,
            type: null,
            options: [{ optionValue: null }],
            required: yesLabel,
          }
        ]
      }
    ],
    attachmentsPanel: {
      addPanel: false,
      attachmentsRequired: false,
      maxSizeMB: maxAttachmentsSize,
      additionalText: '',
      formatDocx: false,
      formatJpg: false,
      formatPdf: false,
      formatZip: false,
    },
    defaultBasicInfo: defBasic,
    defaultSections: defSections,
    defaultAttachmentsPanel: defAttachments,
    errors: {},
    sectionErrors: {},
    fieldsErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    dragItem: null,
    dragOverItem: null,
    draggingStarted: false,
    dragFieldItem: null,
    dragOverFieldItem: null,
    draggingFieldStarted: false,
    filter_text: '',
    service_filter_text: '',
    all_created_services: [],
    showModal: false,
    showDeleteModal: false,
    isEditingData: false,
    testingXmlFile: {
      name: null,
      extension: null,
      data: null,
      loaded: false,
    },
    testingXmlFileResult: {
      success: false,
      fileName: null,
      jobId: null,
    },
    testingDocxFile: {
      name: null,
      extension: null,
      data: null,
      loaded: false,
    },
    testingDocxFileResult: {
      success: false,
      fileName: null,
      jobId: null,
    },
    uploadingXmlFile: {
      name: null,
      extension: null,
      data: null,
      loaded: false,
    },
    uploadingDocxFile: {
      name: null,
      extension: null,
      data: null,
      loaded: false,
    },
  };

  validators = {
    title: [v.NotNull],
    requiresUserInfo: [v.NotSelected],
    requiresMap: [v.NotSelected],
    isEnabled: [v.NotSelected],
    cost: [v.NotNull, v.isNumber, v.isCost],

    addPanel: [v.NotSelected],
    attachmentsRequired: [v.NotSelected],
    maxSizeMB: [v.NotNull, v.isNumber, v.maxValue(70)],

    sectionTitle: [v.NotNull],
    additionalText: [],

    fieldTitle: [v.NotNull],
    type: [v.NotSelected],
    required: [v.NotSelected],

    optionValue: [v.NotNull],
  };

  componentDidMount = () => {
    const colors = getThemeFromLocalStorage();
    this.fetchDistrict();
    let sourceStyle = layoutColorStyle;
    const style = {
      color: sourceStyle[colors].color,
      display: 'block',
      backgroundColor: null,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style.color = sourceStyle[colors].color;
      style.backgroundColor = sourceStyle[colors].backgroundColor;
      style.display = 'block';
    }
    this.setState({ colors, sourceStyle, style });
  }

  async fetchDistrict() {
    if (this.props.isDistrictAdmin) {
      const selectedDistrict = await getDistrictForUser(this.props.user.ID);
      this.setState({ selected_district: selectedDistrict }, () => this.fetchCreatedServices(selectedDistrict));
    } else {
      this.setState({ selected_district: null });
    }
  }

  updateValidators = () => {
    if (this.state.mode === MODE_TYPES.CREATE) {
      const allTitles = [];
      for (const service of this.state.all_created_services) {
        allTitles.push(service.title);
      }
      this.validators.title = [v.NotNull, v.CheckTitle(allTitles)];
    } else {
      this.validators.title = [v.NotNull];
    }
  }

  async fetchCreatedServices(prefix) {
    const url = `${process.env.API_URL}/eservices/service/get_all_created/${prefix}/`;
    await fetch(url)
      .then(r => r.json())
      .then(resp => {
        this.setState({ all_created_services: resp.data }, this.updateValidators);
      });
  }

  async fetchCreatedServiceData(shortName) {
    const url = `${process.env.API_URL}/eservices/service/get/${shortName}/`;
    await fetch(url)
      .then(r => r.json())
      .then(resp => {
        const data = resp.data;
        const basicInfo = data.basicInfo;
        if (basicInfo.cost === 0) {
          basicInfo.cost = '0.00';
        } 
        this.setState({
          basicInfo: basicInfo,
          defaultBasicInfo: data.basicInfo, 
          sections: data.sections,
          defaultSections: data.sections,
          attachmentsPanel: data.attachmentsPanel,
          defaultAttachmentsPanel: data.attachmentsPanel,
          mode: MODE_TYPES.EDIT,
          shortName,
          isEditingData: false,
        }, this.updateValidators);
      });
  }

  districtFilterChange = (e, state) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ [state]: value });
  };

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: prefix }, () => this.fetchCreatedServices(prefix));
  };

  onClickService = (item) => {
    this.fetchCreatedServiceData(this.state.all_created_services[item].shortName);
  };

  saveService = () => {
    const serviceData = {
      mode: this.state.mode,
      shortName: this.state.shortName,
      selected_district: this.state.selected_district,
      basicInfo: this.state.basicInfo,
      sections: this.state.sections,
      attachmentsPanel: this.state.attachmentsPanel,
    };

    let successMessage = 'Usługa została utworzona. Wymagane jest odświeżenie strony.';
    if (this.state.mode === MODE_TYPES.EDIT) {
      successMessage = 'Usługa została zaktualizowana. Wymagane jest odświeżenie strony.';
    }
    fetch(`${process.env.API_URL}/eservices/service/create/`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceData),
      },
    ).then((response) => {
      this.setState({
        errorText: successMessage,
        errorTitle: successMessage,
        showError: true });
        window.location.reload();
    });
  }

  deleteService = () => {
    const successMessage = 'Usługa została usunięta. Wymagane jest odświeżenie strony.';
    fetch(`${process.env.API_URL}/eservices/service/delete/${this.state.shortName}/`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    ).then((response) => {
      this.setState({
        errorText: successMessage,
        errorTitle: successMessage,
        showError: true });
        window.location.reload();
    });
  }

  addService = () => {
    this.setState({
      mode: 'create',
      shortName: null,
      basicInfo: defBasic,
      defaultBasicInfo: defBasic,
      sections: defSections,
      defaultSections: defSections,
      attachmentsPanel: defAttachments,
      defaultAttachmentsPanel: defAttachments,
      isEditingData: false,
    }, this.updateValidators);
  }

  async uploadTemplate(templateType) {
    if (this.state.isEditingData) {
      this.setState({
        errorText: operationErrorMessage,
        errorTitle: operationErrorTitle,
        showError: true
      });
      return;
    }

    const templateTestingResult = await this.validateTemplate(templateType, false);
    if (!templateTestingResult) {
      this.setState({
        errorText: templateTestingErrorText,
        errorTitle: templateTestingErrorTitle,
        showError: true
      });
      return;
    }

    let template = this.state.uploadingXmlFile;
    if (templateType === TEMPLATE_TYPES.DOCX) {
      template = this.state.uploadingDocxFile;
    }

    await fetch(`${process.env.API_URL}/eservices/service/upload_template/${templateType}/${this.state.shortName}/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({attachment: template,}),
    },
  ).then(r => r.json())
  .then(resp => {
    if (resp.message === 'OK') {
      const successMessage = 'Szablon zapisany. Wymagane jest odświeżenie strony.';
      this.setState({
        errorText: successMessage,
        errorTitle: successMessage,
        showError: true
      });
      window.location.reload();
    } else {
      const errorMessage = 'Wystąpił błąd podczas zapisywania szablonu.';
      this.setState({
        errorText: errorMessage,
        errorTitle: 'Wystąpił nieoczekiwany błąd.',
        showError: true
      });
      return;
    }
  });
  }

  async testTemplate (templateType) {
    const templateTestingResult = await this.validateTemplate(templateType);
    if (templateTestingResult) {
      const successText = 'Test szablonu zakończony pozytywnie. Sprawdź zawartość wygenerowanego pliku w celu ostatecznego sprawdzenia jego poprawności.';
      const successTitle = 'Test szablonu zakończony pozytywnie.'
      this.setState({
        errorText: successText,
        errorTitle: successTitle,
        showError: true
      });
      return;
    }
    this.setState({
      errorText: templateTestingErrorText,
      errorTitle: templateTestingErrorTitle,
      showError: true
    });
    return;

  }

  async validateTemplate(templateType, testing=true) {
    let testSuccess = false;

    let template = this.state.testingXmlFile;
    const inputId = `${templateType}TestInput`;
    if (templateType === TEMPLATE_TYPES.DOCX && testing) {
      template = this.state.testingDocxFile;
    }
    if (templateType === TEMPLATE_TYPES.XML && !testing) {
      template = this.state.uploadingXmlFile;
    }
    if (templateType === TEMPLATE_TYPES.DOCX && !testing) {
      template = this.state.uploadingDocxFile;
    }
    
    await fetch(`${process.env.API_URL}/eservices/service/test_template/${templateType}/${this.state.shortName}/`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({attachment: template, userId: this.props.user.ID}),
      },
    ).then(r => r.json())
    .then(resp => {
      if (resp.message === 'OK') {
        testSuccess = true;
        if (testing) {
          const testResult = {
            success: true,
            fileName: resp.file_name,
            jobId: resp.job_id,
          }
          if (templateType === TEMPLATE_TYPES.XML) {
            this.setState({ testingXmlFileResult: testResult }, () => this.resetInputFiles(templateType));
          } else {
            this.setState({ testingDocxFileResult: testResult }, () => this.resetInputFiles(templateType));
          }
        }
      } else {
        this.resetTestingRestults(templateType);
      }
      document.getElementById(inputId).value = "";
    });

    return testSuccess;
  }

  resetInputFiles = (fileType) => {
    const defaultFile =  {
      name: null,
      extension: null,
      data: null,
      loaded: false,
    }

    let stateToChangeInput = 'testingXmlFile';
    if (fileType === TEMPLATE_TYPES.DOCX) {
      stateToChangeInput = 'testingDocxFile'; 
    }
    this.setState({ [stateToChangeInput]: defaultFile });
  }

  resetTestingRestults = (fileType) => {
    const testResult = {
      success: false,
      fileName: null,
      jobId: null,
    }

    let stateToChangeTestingResult = 'testingXmlFileResult';
    if (fileType === TEMPLATE_TYPES.DOCX) {
      stateToChangeTestingResult = 'testingDocxFileResult'; 
    }
    this.setState({ [stateToChangeTestingResult]: testResult }, () => this.resetInputFiles(fileType));
  }

  onFileChange = (e, type, testing=true) => {
    const file = e.target.files[0];
    if (file) {
      const name = file.name;
      if (!name) {
        const errorText = `Nazwa pliku jest niepoprawna. Nie może zawierać polskich znaków.`;
        const errorTitle = 'Błędna nazwa pliku.';
        const fileData = {
          name: null,
          extension: null,
          data: null,
          loaded: false,
        }
        this.setState({
          [stateToChange]: fileData,
          errorText: errorText,
          errorTitle: errorTitle,
          showError: true,
        });
        e.target.value = null;
        return;
      }
      const extension = name.split('.').slice(-1)[0];

      let stateToChange = 'testingXmlFile';
      if (type === TEMPLATE_TYPES.DOCX && testing) {
        stateToChange = 'testingDocxFile';
      }
      if (type === TEMPLATE_TYPES.XML && !testing) {
        stateToChange = 'uploadingXmlFile';
      }
      if (type === TEMPLATE_TYPES.DOCX && !testing) {
        stateToChange = 'uploadingDocxFile';
      }

      if (extension === type) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = event => {
          const data = event.target.result;
          const fileData = {
            name: name,
            extension: extension,
            data: data,
            loaded: true,
          };
          if (type === TEMPLATE_TYPES.XML) {
            this.setState({ [stateToChange]: fileData });
          } else {
            this.setState({ [stateToChange]: fileData });
          }
        }
      } else {
        const errorText = `Wybrany format pliku jest niepoprawny. Wymagane rozszerzenie pliku to .${type}`;
        const errorTitle = 'Błędny format pliku.';
        const fileData = {
          name: null,
          extension: null,
          data: null,
          loaded: false,
        }
        this.setState({
          [stateToChange]: fileData,
          errorText: errorText,
          errorTitle: errorTitle,
          showError: true,
        });
        e.target.value = null;
        return;
      }
    }
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
        isEditingData: true,
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (group === 'attachmentsPanel' && name === 'addPanel' && e.value == false) {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            attachmentsRequired: false,
          },
          isEditingData: true,
        },
        () => this.validate(group, name),
      );
    }
    else if (group === 'attachmentsPanel' && name === 'attachmentsRequired' && e.value == true) {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            addPanel: true,
          },
          isEditingData: true,
        },
        () => this.validate(group, name),
      );
    }
    else {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
          isEditingData: true,
        },
        () => this.validate(group, name),
      );
    }
  }

  onChangeCheckbox = (e, group, state) => {
    const arr = this.state[group];

    arr[state] = e.target.checked;
    this.setState({
      [group]: arr,
      isEditingData: true,
    });
  }


  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const field of fields) {
      const checks = this.validateField(group, field);
      errors[field] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null, checkSections = false) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['basicInfo', 'attachmentsPanel'];
      for (const group of grupy) {
        const err = this.validateGroup(group);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }

    if (checkSections) {
      this.validateSections('sectionErrors', 'sections');
      this.validateSections('fieldErrors', 'fields');
    }
  };

  addSection = () => {
    const item = {
      sectionTitle: null,
      additionalText: null,
      fields: [
        {
          fieldTitle: null,
          type: null,
          options: [],
          required: yesLabel,
        }
      ]
    };

    this.setState({
      sections: [...this.state.sections, item],
      isEditingData: true,
    }, () => this.validateSections('sectionErrors'));
  }

  removeSection = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
      isEditingData: true,
      }, () => this.validateSections('sectionErrors')
    );
  }

  validateSections = (errorField, group = null, field = null, index = null, subidx = null, subgroup = null, subsubidx = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateSectionField(group, field, index, subidx, subgroup, subsubidx);
      if (subidx !== null) {
        if (subsubidx !== null) {
          newState = {
            ...this.state[errorField],
            [`${index}${field}${subidx}${subsubidx}`]: checks,
          };
        } else {
          newState = {
            ...this.state[errorField],
            [`${index}${field}${subidx}`]: checks,
          };
        }

      } else {
        newState = {
          ...this.state[errorField],
          [`${field}${index}`]: checks,
        };
      }

    } else {
      if (group) {
        let errors = {};
        const err = this.validateListGroups(group, subgroup);
        errors = { ...errors, ...err };
        newState = { ...errors };
      }
    }

    if (newState) {
      this.setState({ [errorField]: newState });
    }
  };

  validateListGroups = (group, subgroup = null, subsubidx = null) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          let subgrp = Object.keys(obj)[i];
          if (subgroup !== null) {
            subgrp = subgroup;
          }
          if (group === 'sections' && subgrp === 'fields') {
            let subidx = 0;
            for (const fieldDict of this.state[group][idx][subgrp]) {
              for (const index in Object.keys(fieldDict)) {
                const field = Object.keys(fieldDict)[index];
                if (field === 'type' && fieldDict.type === 'Select') {
                  let subsubidx = 0;
                  for (const option of fieldDict.options) {
                    const checks = this.validateSectionField(group, 'optionValue', idx, subidx, subgrp, subsubidx);
                    errors[`${idx}${'optionValue'}${subidx}${subsubidx}`] = checks;
                    subsubidx += 1;
                  }
                }
                const checks = this.validateSectionField(group, field, idx, subidx, subgrp, subsubidx);
                errors[`${idx}${field}${subidx}`] = checks;
              }
              subidx += 1;
            }
          }
          else {
            const field = subgrp;
            const checks = this.validateSectionField(group, field, idx);
            errors[`${field}${idx}`] = checks;
          }
        }
        idx += 1;
      }
    }
    return errors;
  };

  validateSectionField = (group, field, index, subidx = null, subgroup = null, subsubidx = null) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        let check = null;
        if (subidx !== null && subgroup !== null) {
          if (subsubidx !== null) {
            check = validator(this.state[group][index][subgroup][subidx].options[subsubidx][field]);
          } else {
            check = validator(this.state[group][index][subgroup][subidx][field]);
          }
        } else {
          check = validator(this.state[group][index][field]);
        }
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  haseErrors = () => {
    for (const val of Object.values(this.state.errors)) {
      if (val.length > 0) return true;
    }
    for (const val of Object.values(this.state.sectionErrors)) {
      if (val.length > 0) return true;
    }
    return false;
  };

  validateBeforeModal = () => {
    this.validate(null, null, this.checkFieldErrors, true);
  }

  checkOptions = () => {
    let correctOptions = true;
    for(const section of this.state.sections) {
      for (const field of section.fields) {
        if (field.type === 'Select' && field.options.length === 0) {
          correctOptions = false;
          break;
        }
      }
    }

    return correctOptions;
  }

  cancelEdit = () => {
    this.setState({
      isEditingData: false,
      basicInfo: this.state.defaultBasicInfo,
      attachmentsPanel: this.state.defaultAttachmentsPanel,
      sections: this.state.defaultSections,
    });
  }

  checkSectionsContent = () => {
    for (const section of this.state.sections) {
      if (section.fields.length === 0) {
        return false;
      }
    }

    return true;
  } 

  checkFieldErrors = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    const anyAttachmentSelected = [this.state.attachmentsPanel.formatDocx, this.state.attachmentsPanel.formatJpg, this.state.attachmentsPanel.formatPdf, this.state.attachmentsPanel.formatZip].includes(true);
    if (this.state.attachmentsPanel.addPanel && !anyAttachmentSelected) {
      this.setState({
        errorText: 'W informacjach o panelu załączników należy wybrać przynajmniej jeden format plików.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    const correctOptions = this.checkOptions();
    if (!correctOptions) {
      this.setState({
        errorText: 'W polach wyboru należy dodać przynajmniej jedną opcję wyboru.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    const sectionsOK = this.checkSectionsContent()
    if (!sectionsOK) {
      this.setState({
        errorText: 'W przynajmniej jednej sekcji nie dodano żadnego pola.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    this.showModalAlert();
  }

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  showDeleteModalAlert = () => {
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
    });
  }

  onHide = () => this.setState({ showError: false });

  // modal z potwierdzeniem lub odrzuceniem zmian
  confirmModal = () => {
    return (
      <div className={styles.modal}>
        <div className={styles.modal__container} style={this.state.style}>
          <div className={styles.modal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={styles.cardButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.saveService} className={`btn btn-success ${styles.cardButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>

    );
  }

  // modal z potwierdzeniem lub odrzuceniem zmian
  deleteModal = () => {
    return (
      <div className={styles.modal}>
        <div className={styles.modal__container} style={this.state.style}>
          <div className={styles.modal__header}>Czy na pewno chcesz usunąć e-usługę?</div>
          <div className={styles.cardButtons}>
            <button onClick={this.showDeleteModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.deleteService} className={`btn btn-success ${styles.cardButtons__right}`}>Usuń</button>
          </div>
        </div>
      </div>

    );
  }

  renderCheckbox = (group, state, label) => {
    return (
      <div style={{ width: '100%', display: 'flex' }}>
        <div className={leftCol} />
        <div className={'col-sm-10'}>
          <input
            id={`${group}_${state}`}
            name={`${group}_${state}`}
            type="checkbox"
            value={this.state[group][state]}
            onChange={(e) => this.onChangeCheckbox(e, group, state)}
            checked={this.state[group][state]}
          />
          <label htmlFor={`${group}_${state}`}>&nbsp;&nbsp;{label}</label>
        </div>
        <div className={rightCol} />
      </div>
      
    )
  }

  onChangeSection = (e, group, elem, idx) => {
    const arr = this.state[group];
    arr[idx][elem] = e.target.value;
    this.setState({
      [group]: arr,
      isEditingData: true,
    },  () => this.validateSections('sectionErrors', group, elem, idx),
    );
  };

  addField = (idx) => {
    const sections = _.cloneDeep(this.state.sections);
    sections[idx].fields = [...sections[idx].fields, 
      {
        fieldTitle: null,
        type: null,
        options: [],
        required: yesLabel,
      }
    ];
    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections'));
  }

  removeField = (idx, subidx) => {
    const sections = _.cloneDeep(this.state.sections);

    if (subidx > -1) {
      sections[idx].fields.splice(subidx, 1);
    }

    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections'));
  }



  onChangeField = (e, elem, index, subidx, subsubidx = null) => {
    const sections = this.state.sections;
    if (subsubidx != null) {
      sections[index].fields[subidx].options[subsubidx][elem] = e.target.value;
    } else {
      sections[index].fields[subidx][elem] = e.target.value;
    }
    

    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections', elem, index, subidx, 'fields', subsubidx));
  }

  onChangeFieldSelect = (e, elem, index, subidx) => {
    const sections = this.state.sections;
    sections[index].fields[subidx][elem] = e.value;

    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections', elem, index, subidx, 'fields'));
  }

  addOption= (idx, subidx) => {
    const sections = _.cloneDeep(this.state.sections);
    sections[idx].fields[subidx].options = [...sections[idx].fields[subidx].options, 
      {
        optionValue: null,
      }
    ];
    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections'));
  }

  removeOption= (idx, subidx, subsubidx) => {
    const sections = _.cloneDeep(this.state.sections);

    if (subidx > -1) {
      sections[idx].fields[subidx].options.splice(subsubidx, 1);
    }

    this.setState({
      sections,
      isEditingData: true,
    }, () => this.validateSections('fieldsErrors', 'sections'));
  }

  getInputWithError = (description, group, field, idx, value, placeholder, errorsState) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        type="text"
        className="form-control"
        key={`input_${field}${idx}`}
        name={`input_${field}${idx}`}
        autoComplete='none'
        style={this.errorStyle(errorsState, `${field}${idx}`)}
        value={value ? value : ''}
        placeholder={placeholder}
        onChange={e => this.onChangeSection(e, group, field, idx, errorsState)}
      />
      {this.renderErrorsInSpan(errorsState, `${field}${idx}`)}
    </div>
  )

  getIndexedInputWithError = (field, idx, subidx, value, placeholder, errorsState) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        key={`input_${idx}${field}${subidx}`}
        name={`input_${idx}${field}${subidx}`}
        autoComplete='none'
        style={this.errorStyle(errorsState, `${idx}${field}${subidx}`)}
        value={value ? value : ''}
        placeholder={placeholder}
        onChange={e => this.onChangeField(e, field, idx, subidx)}
      />
      {this.renderErrorsInSpan(errorsState, `${idx}${field}${subidx}`)}
    </div>
  )

  getSubIndexedInputWithError = (field, idx, subidx, subsubidx, value, placeholder, errorsState) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        key={`input_${idx}${field}${subidx}${subsubidx}`}
        name={`input_${idx}${field}${subidx}${subsubidx}`}
        autoComplete='none'
        style={this.errorStyle(errorsState, `${idx}${field}${subidx}${subsubidx}`)}
        value={value ? value : ''}
        placeholder={placeholder}
        // disabled={!this.state[editingState]}
        onChange={e => this.onChangeField(e, field, idx, subidx, subsubidx)}
      />
      {this.renderErrorsInSpan(errorsState, `${idx}${field}${subidx}${subsubidx}`)}
    </div>
  )

  getIndexedSelectWithError = (field, idx, subidx ,value, options, errorsState) => (
    <div style={{ textAlign: 'justify' }}>
      <Select
        noResultsText={'brak wyników'}
        clearable={false}
        options={options}
        value={value}
        placeholder={'Wybierz z listy...'}
        onChange={e => this.onChangeFieldSelect(e, field, idx, subidx)}
        style={this.errorStyle(errorsState, `${idx}${field}${subidx}`)}
        onBlur={event => event.preventDefault()}
        optionClassName="needsclick"
        blurInputOnSelect={false}
      />
      {this.renderErrorsInSpan(errorsState, `${idx}${field}${subidx}`)}
    </div>
  )

  errorStyle = (errorsState, errorField) => (
    {
      width: '100%',
      borderColor:
        Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
          this.state[errorsState][errorField] !== null &&
          this.state[errorsState][errorField].length > 0
          ? 'red'
          : '#ccc',
    }
  )

  renderErrorsInSpan = (errorsState, errorField) => {
    return (    
      <div>
      {Object.keys(this.state[errorsState]).indexOf(errorField) > -1 &&
      this.state[errorsState][errorField] !== null &&
      this.state[errorsState][errorField].length > 0
      ? this.state[errorsState][errorField].map((val) => (
        <span key={val} style={errorSpanStyle}>
          {val}
        </span>
      ))
      : null}
    </div>)
    }

  dragStart = (e, position, state) => {
    let dragItem = this.state[state];
    dragItem = position;
    this.setState({ [state]: dragItem });
  };
   
  dragEnter = (e, position, state) => {
    let dragOverItem = this.state[state];
    dragOverItem = position;
    this.setState({ [state]: dragOverItem });
  };

  dropSection = (listState, dragItemState, dragOverItemState, draggingStartedField, sectionsIndex = null) => {
    const copyListItems = [...listState];
    let dragItem = this.state[dragItemState];
    const dragItemContent = copyListItems[dragItem];
    let dragOverItem = this.state[dragOverItemState];
    copyListItems.splice(dragItem, 1);
    copyListItems.splice(dragOverItem, 0, dragItemContent);
    let sections = copyListItems;
    if (sectionsIndex !== null) {
      sections = this.state.sections;
      sections[sectionsIndex].fields = copyListItems;
    }
    dragItem = null;
    dragOverItem = null;
    this.setState({ sections, [draggingStartedField]: false, [dragItemState]: dragItem, [dragOverItemState]: dragOverItem, isEditingData: true }, () => this.validateSections('sectionErrors'));
  };

  onMouseDown = (state) => {
    this.setState({ [state]: true });
  };

  onMouseUp = (state) => {
    this.setState({ [state]: false });
  };

  scrollToSection = (field) => {
    scroller.scrollTo(field, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -200,
    });
  };

  renderSection = (data, i) => {
    return (
      <div
        style={{ marginTop: '60px' }}
        key={i}
      >
        <GrayPanel title={data.sectionTitle}>
          <button
            id={`move_section_${i}`}
            type="submit"
            style={{ cursor: this.state.draggingStarted ? 'grabbing' : 'grab', width: '100%', paddingBottom: '10px', paddingTop: '10px', marginBottom: '20px' }}

            draggable
            onMouseDown={() => this.onMouseDown('draggingStarted')}
            onMouseUp={() => this.onMouseUp('draggingStarted')}
            onDragStart={(e) => this.dragStart(e, i, 'dragItem')}
            onDragEnter={(e) => this.dragEnter(e, i, 'dragOverItem')}
            onDragEnd={(e) => this.dropSection(this.state.sections, 'dragItem', 'dragOverItem', 'draggingStarted')}
            key={i}
          >
            Przesuń sekcję
          </button>
          {this.getInputWithError('Tytuł sekcji','sections', 'sectionTitle', i, data.sectionTitle, 'Tytuł...', 'sectionErrors')}
          {this.getInputWithError('Dodatkowy opis','sections', 'additionalText', i, data.additionalText, 'Opis...', 'sectionErrors')}
          <br />
          <p>Lista pól:</p>

          {this.renderFieldsList(i)}
          <p>* - W przypadku pola wyboru.</p>

          <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSection(i, 'sections')}
          >
            Usuń sekcję
          </button>
        </GrayPanel>
      </div>
    )
  }

  renderFieldsList = (idx) => {
    return (
      <table className="table">
      <thead>
        <tr>
          <th scope="col">LP</th>
          <th scope="col">Nazwa pola</th>
          <th scope="col">Typ pola</th>
          <th scope="col">Wymagane?</th>
          <th scope="col">Opcje do wyboru*</th>
          <th scope="col">
            <button
              type="submit-lg"
              className={'btn btn-success'}
              style={{ btnStyle }}
              onClick={() => this.addField(idx)}
            >
              +
              </button>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {this.state.sections[idx].fields.map((v, i) => {
          return (
            <tr
              key={i}
            >
              <td style={{ width: '5%' }}>{i + 1}</td>
              <td style={{ width: '20%' }}>
                {this.getIndexedInputWithError('fieldTitle', idx, i, v.fieldTitle, 'Nazwa pola...', 'fieldsErrors')}
              </td>
              <td style={{ width: '15%' }}>
                {this.getIndexedSelectWithError('type', idx, i, v.type, fieldTypes, 'fieldsErrors')}
              </td>
              <td style={{ width: '10%' }}>
                {this.getIndexedSelectWithError('required', idx, i, v.required, requiredFieldOptions, 'fieldsErrors')}
              </td>
              <td style={{ width: '35%' }}>
                {this.state.sections[idx].fields[i].type === 'Select' ?
                  <div>
                  <button
                    type="submit-lg"
                    className={'btn btn-success'}
                    style={{ btnStyle }}
                    onClick={() => this.addOption(idx, i)}
                  >
                    Dodaj opcję
                    </button>
                  <table className="table">
                    <tbody>
                      {this.state.sections[idx].fields[i].options.map((v, subidx) => {
                        return (
                          <tr key={`field_row${i}_${idx}_${subidx}`}>
                            <td>
                            <button
                              type="submit-lg"
                              className={'btn btn-danger'}
                              style={{ btnStyle }}
                              onClick={() => this.removeOption(idx, i, subidx)}
                            >
                              X
                              </button>
                          </td>
                          <td>
                            {this.getSubIndexedInputWithError('optionValue', idx, i, subidx, v.optionValue, 'Wartość...', 'fieldsErrors')}
                            </td>
                          </tr>
                        )})}
                      </tbody>
                    </table>
                  </div>
                  : null
                  
                }
              </td>

              <td style={{ width: '5%' }}>
                <button
                  type="submit-lg"
                  className={'btn btn-danger'}
                  style={{ btnStyle }}
                  onClick={() => this.removeField(idx, i)}
                >
                  X
                  </button>
              </td>
              <td style={{ width: '10%' }}>
                <button
                  id={`move_field_${idx}_${i}`}
                  type="submit"
                  key={i}
                  style={{ cursor: this.state.draggingFieldStarted ? 'grabbing' : 'grab', paddingBottom: '5px', paddingTop: '5px' }}
                  draggable
                  onMouseDown={() => this.onMouseDown('draggingFieldStarted')}
                  onMouseUp={() => this.onMouseUp('draggingFieldStarted')}
                  onDragStart={(e) => this.dragStart(e, i, 'dragFieldItem')}
                  onDragEnter={(e) => this.dragEnter(e, i, 'dragOverFieldItem')}
                  onDragEnd={(e) => this.dropSection(this.state.sections[idx].fields, 'dragFieldItem', 'dragOverFieldItem', 'draggingFieldStarted', idx)}
                >
                  Przesuń pole
                </button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    )
  }

  renderTiles = (filter_field, state) => {
    let objectsList = this.state.all_created_services && Object.keys(this.state.all_created_services).sort()
      .filter(item => this.state.all_created_services[item].title.toLowerCase().includes(this.state[filter_field].toLowerCase()));
    if (state === 'districts') {
      objectsList = this.props.districts && Object.keys(this.props.districts).sort()
        .filter(item => this.props.districts[item].name.toLowerCase().includes(this.state[filter_field].toLowerCase()));
    }
    return(
      <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
        <h4 style={{ textAlign: 'center' }}>
          {state === 'districts' ? <b>Urzędy:</b> : <b>Utworzone e-usługi:</b>}
        </h4>
        <input
          type="text"
          className="form-control"
          style={{ width: '100%', position: 'relative', margin: '25px 0 15px 0' }}
          value={this.state[filter_field]}
          placeholder="Wyszukaj..."
          disabled={state === 'all_created_services'? !this.state.selected_district : false}
          onChange={(e) => this.districtFilterChange(e, filter_field)}
        />
        {state === 'districts' ?
        <ul className={'nav flex-column'} style={{ height: objectsList.length >= 8 ? '300px' : 'auto', overflowY: 'scroll' }}>
          {objectsList.length ? objectsList.map(item => (
            <li className={'nav-item'} key={item}>
              <button
                type="button"
                className={'btn btn-primary'}
                style={btnStyle}
                onClick={() => this.onClick(item)}
              >
                {this.props.districts[item].name}
              </button>
            </li>
            )) : <p style={{ textAlign: 'center' }}>brak wyników</p>}
        </ul>: null}
        {state === 'all_created_services' ?
        <ul className={'nav flex-column'} style={{ height: objectsList.length >= 8 ? '300px' : 'auto', overflowY: 'scroll' }}>
          {objectsList.length ? objectsList.map(item => (
            <li className={'nav-item'} key={item}>
              <button
                type="button"
                className={'btn btn-primary'}
                style={btnStyle}
                onClick={() => this.onClickService(item)}
              >
                {this.state.all_created_services[item].title}
              </button>
            </li>
          )) : <p style={{ textAlign: 'center' }}>brak wyników</p>}
        </ul> : null}
      </div>
    )
  }

  renderAddServiceButton = () => {
    return(
      <div>
        <div className="col-sm-2" />
        <div className="col-sm-8" >
          <button
            type="submit-lg"
            className={'btn btn-primary'}
            style={{ float: 'center', marginBottom: '20px', ...btnStyle}}
            disabled={!this.state.selected_district && !this.state.isEditingData}
            onClick={() => this.addService()}
          >
            Dodaj nową e-usługę
          </button>
        </div>
        <div className="col-sm-2" />
      </div>
    )
  }

  renderSelectedDistrictLabel = () => {
    const label = `Wybrany Urząd: ${this.props.districts[this.state.selected_district].name}`;
    return(
      <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
        <h4 style={{ textAlign: 'center' }}>
          <b>{label}</b>
        </h4>
      </div>
    )
  }

  renderServiceStatusRow = () => {
    const title = 'Status e-usługi: '
    const isReady = this.state.defaultBasicInfo.requiresUserInfo? this.state.basicInfo.docxTplAdded && this.state.basicInfo.xmlTplAdded : this.state.basicInfo.docxTplAdded;
    return(
      <tr>
        <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
        <th style={{ width: '10%' }} />
        <th style={{ width: '15%', textAlign: 'center' }}>
          {isReady ?
            <input type="text" disabled className='form-control' style={{ color: 'green', textAlign: 'center' }} value='Gotowa' /> :
            <input type="text" disabled className='form-control' style={{ color: 'red', textAlign: 'center' }} value='Niegotowa' />}
        </th>
        <th style={{ width: '10%' }} />
        <th style={{ width: '15%' }} />
        <th style={{ width: '10%' }} />
      </tr>
    )
  }

  renderTemplateInfoRow = (templateType) => {
    const title = `Czy poprawnie został wgrany szablon .${templateType}:`
    const enabledTitle = 'Kliknij, aby pobrać.';
    const disabledTitle = 'Pobranie pliku niemożliwe - plik nie został wrgany.';
    const teryt = this.props.districts[this.state.selected_district].teryt
    const href = `${process.env.API_URL}/eservices/service/download_template/${teryt}/${templateType}/${this.state.shortName}/`;

    const state = templateType === TEMPLATE_TYPES.DOCX ? this.state.basicInfo.docxTplAdded : this.state.basicInfo.xmlTplAdded
    return(
      <tr>
        <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
        <th style={{ width: '10%' }} />
        <th style={{ width: '15%', textAlign: 'center' }}>
          {state ?
            <input type="text" disabled className='form-control' style={{ color: 'green', textAlign: 'center' }} value={yesLabel} /> :
            <input type="text" disabled className='form-control' style={{ color: 'red', textAlign: 'center' }} value={noLabel} />}
        </th>
        <th style={{ width: '10%' }} />
        <th style={{ width: '15%' }}>
          <a
            className="btn btn-primary"
            target="_blank"
            href={state ? href : null}
            style={{ float: 'center', ...btnStyle}}
            title={!state ? disabledTitle : enabledTitle}
            disabled={!state}
          >
            Pobierz
          </a>
        </th>
        <th style={{ width: '10%' }} />
      </tr>
    )
  }

  renderDownloadXMLRow = () => {
    const title = 'Pobieranie pustego szablonu .xml (wymaga uzupełnienia)';
    const enabledTitle = 'Kliknij, aby pobrać.';
    return(
      <tr>
        <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
        <th style={{ width: '35%' }} />
        <th style={{ width: '15%' }}>
          <a
            className="btn btn-primary"
            target="_blank"
            href={`${process.env.API_URL}/eservices/service/get_empty_xml_template/`}
            style={{ float: 'center', ...btnStyle}}
            title={enabledTitle}
          >
            Pobierz
          </a>
        </th>
        <th style={{ width: '10%' }} />
      </tr>
    )
  }

  renderKeysGeneratorRow = (templateType) => {
    const title = `Generowanie kluczy do szablonu .${templateType}`;
    const enabledTitle = 'Kliknij, aby wygenerować i pobrać plik z kluczami.';
    return(
      <tr>
        <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
        <th style={{ width: '35%' }} />
        <th style={{ width: '15%' }}>
          <a
            className="btn btn-primary"
            target="_blank"
            href={!this.state.isEditingData ? `${process.env.API_URL}/eservices/service/create_template_keys/${templateType}/${this.state.shortName}/`: null}
            style={{ float: 'center', ...btnStyle}}
            disabled={this.state.isEditingData}
            title={this.state.isEditingData ? disabledTitle : enabledTitle}
          >
            Generuj
          </a>
        </th>
        <th style={{ width: '10%' }} />
      </tr>
    )
  }

  renderTemplateTestingRow = (templateType) => {
    const title = `Testowanie i podgląd szablonu .${templateType}`;
    const enabledDownloadTitle = 'Kliknij, aby pobrać szablon uzupełniony danymi testowymi.';
    const enabledTestTitle = 'Kliknij, aby sprawdzić poprawność szablonu.';
    const disabledDownloadTitle = 'Nie można wykonać czynności - nie przetestowano szablonu lub test dał wynik negatywny.';
    const downloadFileDisabled = (templateType === TEMPLATE_TYPES.XML && !this.state.testingXmlFileResult.success) || (templateType === TEMPLATE_TYPES.DOCX && !this.state.testingDocxFileResult.success);
    const testFileDisabled = (templateType === TEMPLATE_TYPES.XML && !this.state.testingXmlFile.loaded) || (templateType === TEMPLATE_TYPES.DOCX && !this.state.testingDocxFile.loaded);
    const allDisabled = this.state.isEditingData;
    let fileName = this.state.testingXmlFileResult.fileName;
    let jobId = this.state.testingXmlFileResult.jobId;
    const teryt = this.props.districts[this.state.selected_district].teryt
    if (templateType === TEMPLATE_TYPES.DOCX) {
      fileName = this.state.testingDocxFileResult.fileName;
      jobId = this.state.testingDocxFileResult.jobId;
    }
    const fileHref = `${process.env.API_URL}/eservices/service/get_test_result_file/${teryt}/${jobId}/${fileName}/`

    return(
      <table style={{ width: '100%', marginBottom: marginBottom }}>
        <tbody>
          <tr>
            <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
            {/* <th style={{ width: '60%' }} /> */}
          </tr>
          <tr>
            <th style={{ width: '40%'}} >
              <input
                type="file"
                id={`${templateType}TestInput`}
                style={{ color: 'red' }}
                accept={`.${templateType}`}
                onChange={(e) => this.onFileChange(e, templateType)}
                disabled={allDisabled}
                title={allDisabled ? disabledTitle : enabledAddFileTitle}
                />
            </th>
            <th style={{ width: '10%' }} />
            <th style={{ width: '15%', textAlign: 'center' }}>
              <a
                className="btn btn-primary"
                target="_blank"
                href={fileName ? fileHref : null}
                style={{ float: 'center', ...btnStyle}}
                disabled={downloadFileDisabled}
                title={downloadFileDisabled ? disabledDownloadTitle : enabledDownloadTitle}
              >
                Pobierz
              </a>
            </th>
            <th style={{ width: '10%' }} />
            <th style={{ width: '15%' }}>
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'center', ...btnStyle}}
                onClick={() => this.testTemplate(templateType)}
                disabled={allDisabled || testFileDisabled}
                title={allDisabled ? disabledTitle : (testFileDisabled ? disabledUploadTitle : enabledTestTitle)}
              >
                Testuj
              </button>
            </th>
            <th style={{ width: '10%' }}/>
          </tr>
        </tbody>
      </table>
     
    )
  }

  renderTemplateUploadingRow = (templateType) => {
    const title = `Ładowanie szablonu .${templateType}`;
    const enabledUploadFileTitle = 'Kliknij, aby wgrać szablon.';
    const allDisabled = this.state.isEditingData;
    const uploadFileDisabled = (templateType === TEMPLATE_TYPES.XML && !this.state.uploadingXmlFile.loaded) || (templateType === TEMPLATE_TYPES.DOCX && !this.state.uploadingDocxFile.loaded);
    return(
      <table style={{ width: '100%', marginBottom: marginBottom }}>
        <tbody>
          <tr>
            <th style={{ width: '40%', textAlign: 'left' }}>{title}</th>
            {/* <th style={{ width: '60%' }} /> */}
          </tr>
          <tr>
            <th style={{ width: '40%'}} >
              <input
                type="file"
                style={{ color: 'red' }}
                accept={`.${templateType}`}
                onChange={(e) => this.onFileChange(e, templateType, false)}
                disabled={allDisabled}
                title={allDisabled ? disabledTitle : enabledAddFileTitle}
                />
            </th>
            <th style={{ width: '35%' }} />
            <th style={{ width: '15%' }}>
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'center', ...btnStyle}}
                onClick={() => this.uploadTemplate(templateType)}
                disabled={allDisabled || uploadFileDisabled}
                title={allDisabled ? disabledTitle : (uploadFileDisabled ? disabledUploadTitle : enabledUploadFileTitle)}
              >
                Dodaj
              </button>
            </th>
            <th style={{ width: '10%' }} />
          </tr>
        </tbody>
      </table>
     
    )
  }

  redirectToService = () => {
    const href = `/eservices?district=${this.props.districts[this.state.selected_district].teryt}&serviceType=${this.state.shortName}&viewOnly=True`;
    window.open(href, '_blank', 'noopener,noreferrer');
  }

  render() {
    return (
      <Grid>
        <PaperHeader title="Kreator e-usługi" />
        {!this.props.isDistrictAdmin && this.renderTiles('filter_text', 'districts')}
        {this.state.selected_district && this.renderSelectedDistrictLabel()}
        {this.state.selected_district && this.renderAddServiceButton()}
        <br />
        <br />
        {this.state.selected_district ? this.renderTiles('service_filter_text', 'all_created_services') : null}
        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) ?
          <GrayPanel title={'Instrukcja tworzenia e-usługi'}>
            <p id={'EserviceDescriptionPanel'}>Jak poprawnie utworzyć e-usługę:</p>
            <br />
            <p><b>Tworzenie e-usługi:</b></p>
            <p>1. Uzupełnij informacje w oknie <b>"Informacje podstawowe".</b></p>
            <p>2. W oknie <b>"Sekcje formularza"</b> zdefiniuj sekcje oraz pola w nich zawarte.</p>
            <p>3. W oknie <b>"Panel załączników"</b> uzupełnij informacje nt. dodawania załączników do wniosku (jeżeli usługa wymaga logowania).</p>
            <p><b>4. Zapisz zmiany.</b></p>
            <br />
            <p><b>Tworzenie i ładowanie wzorów wniosków:</b></p>
            <br />
            <p>Do tworzenia oraz ładowania wzorów wniosków służy okno <b>"Status e-usługi".</b></p>
            <p><b>E-usługa jest gotowa do użycia dopiero wtedy, gdy załadadowane zostaną szablony wniosków!</b></p>

            <p>1. Pobierz pusty szablon wniosku .xml (jeżeli usługa wymaga logowania) oraz przygotuj wzór wniosku w formacie .docx.</p>
            <p>2. Wygeneruj klucze do szablonów .xml oraz .docx - klucze to oznaczenia, w którym miejscu znajdą się wartości pól z formularza e-usługi.</p>
            <p>3. Uzupełnij szablony .xml oraz .docx za pomocą pobranych kluczy.</p>
            <p>4. Przetestuj poprawność uzpełnienia szablonów za pomocą pobranych kluczy oraz pobierz je w celu ostatecznej weryfikacji lub poprawy.</p>
            <p>5. Załaduj szablony uzupełnione za pomocą pobranych kluczy.</p>
            <p><b>Gotowe!</b> Można już korzystać z e-usługi!</p>
            <br />
            <br />
            <p>Cenne wskazówki:</p>
            <p>* Możesz swobodnie zmieniać kolejność sekcji oraz pól w nich zdefiniowanych.</p>
            <p>** Aktualny wygląd formularza e-usługi możesz zobaczyć pod przyciskiem "Podgląd e-usługi".</p>
            <p>*** Po jakiejkolwiek zmianie definicji e-usługi należy ponownie utworzyć szablony wniosków oraz je załadować.</p>
            <p>**** Wniosek w formacie .xml można podejrzeć na platformie https://gov.pl (<a href='https://moj.gov.pl/nforms/signer/upload?xFormsAppName=SIGNER&xadesPdf=true' target='_blank'>Kliknij, aby przejść.</a>).</p>
            <p>***** W nazwach plików staraj się unikać polskich znaków.</p>
          </GrayPanel>
          : null
        }
        
        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) ?
          <DecisionContainer
            title={'Informacje podstawowe'}
            data={this.state.basicInfo}
            errors={this.state.errors}
            formDict={this.state.basicInfo.requiresUserInfo ? basicDict : basicDict2}
            onChange={e => this.onChange(e, 'basicInfo')}
            onChangeSelect={e => this.onChangeSelect(e, 'basicInfo')}
          >
          </DecisionContainer>  : null}
        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) ?
          <GrayPanel title={'Sekcje formularza'}>
            <p>Aby dodać sekcję kliknij "Dodaj sekcję". Kolejność sekcji można zmienić naciskając przycisk "Przesuń sekcję" i przesuwając ją w odpowiednie miejsce.
              Zmiana kolejności pól w sekcji następuje przy użyciu przycisków "Przesuń pole".
            </p>
            <div className="col-sm-4" />
            <div className="col-sm-4" >
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'center', ...btnStyle}}
                onClick={() => this.addSection()}
              >
                Dodaj sekcję
              </button>
            </div>
            <div className="col-sm-4" />
              {this.state.sections.map((v, i) => {
                    return this.renderSection(v, i)
                  }
                )
              }
          </GrayPanel> : null}
        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) && this.state.basicInfo.requiresUserInfo ?
          <DecisionContainer
            title={'Panel załączników'}
            data={this.state.attachmentsPanel}
            errors={this.state.errors}
            formDict={attachmentsDict}
            onChange={e => this.onChange(e, 'attachmentsPanel')}
            onChangeSelect={e => this.onChangeSelect(e, 'attachmentsPanel')}
          >            
            <div style={{ width: '100%', display: 'flex' }}>
              <div className={leftCol} />
              <div className={'col-sm-10'}>
                <p><b>Formaty załączników:</b></p>
              </div>
              <div className={rightCol} />
            </div>
            {this.renderCheckbox('attachmentsPanel', 'formatDocx', '.docx')}
            {this.renderCheckbox('attachmentsPanel', 'formatJpg', '.jpg')}
            {this.renderCheckbox('attachmentsPanel', 'formatPdf', '.pdf')}
            {this.renderCheckbox('attachmentsPanel', 'formatZip', '.zip')}
          </DecisionContainer> : null}

        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) ?
        <div style={{ display: 'flex', marginBottom: '20px' }} className="col-xs-12">
          <button
            onClick={this.validateBeforeModal}
            disabled={!this.state.isEditingData}
            className="btn btn-success"
            style={{ marginRight: '20px' }}
          >
              Zapisz zmiany
            </button>
          <button
            onClick={this.cancelEdit}
            disabled={!this.state.isEditingData}
            className="btn btn-warning"
            style={{ marginRight: '20px' }}
          >
              Anuluj edycję
            </button>
          <button
            onClick={this.showDeleteModalAlert}
            disabled={!this.state.shortName}
            className="btn btn-danger"
            style={{ marginRight: '20px' }}
          >
              Usuń e-usługę
            </button>
        </div> : null}

        {this.state.selected_district && (this.state.shortName || this.state.mode === MODE_TYPES.CREATE) && !this.state.isEditingData ?
          <GrayPanel title={'Status e-usługi'}>
            <table style={{ width: '100%', marginBottom: marginBottom }}>
              <tbody>
                {this.renderServiceStatusRow()}
              </tbody>
            </table>
            <table style={{ width: '100%', marginBottom: marginBottom }}>
              <tbody>
                {this.renderTemplateInfoRow(TEMPLATE_TYPES.DOCX)}
                <br />
                {this.state.defaultBasicInfo.requiresUserInfo && this.renderTemplateInfoRow(TEMPLATE_TYPES.XML)}
              </tbody>
            </table>
            {this.state.defaultBasicInfo.requiresUserInfo &&
              <table style={{ width: '100%', marginBottom: marginBottom }}>
                <tbody>
                  {this.state.defaultBasicInfo.requiresUserInfo && this.renderDownloadXMLRow()}
                </tbody>
             </table>
            }
            <table style={{ width: '100%', marginBottom: marginBottom }}>
              <tbody>
                {this.renderKeysGeneratorRow(TEMPLATE_TYPES.DOCX)}
                <br />
                {this.state.defaultBasicInfo.requiresUserInfo && this.renderKeysGeneratorRow(TEMPLATE_TYPES.XML)}
              </tbody>
            </table>
            {this.renderTemplateTestingRow(TEMPLATE_TYPES.DOCX)}
            {this.state.defaultBasicInfo.requiresUserInfo && this.renderTemplateTestingRow(TEMPLATE_TYPES.XML)}
            {this.renderTemplateUploadingRow(TEMPLATE_TYPES.DOCX)}
            {this.state.defaultBasicInfo.requiresUserInfo && this.renderTemplateUploadingRow(TEMPLATE_TYPES.XML)}
            <div>
              <div className='col-sm-4' />
              <div className='col-sm-4'>
                <button
                    type="submit-lg"
                    className={'btn btn-primary'}
                    style={{ float: 'center', ...btnStyle}}
                    onClick={() => this.redirectToService()}
                    disabled={!this.state.selected_district || this.state.isEditingData}
                    title={this.state.isEditingData ? disabledTitle : enabledGoToEservice}
                  >
                    Podgląd e-usługi
                  </button>
              </div>
              <div className='col-sm-4' />
            </div>
            <div>
              <div className='col-sm-8' />
              <div className='col-sm-4'>
                <button
                    type="submit-lg"
                    className={'btn btn-warning'}
                    style={{ float: 'center', ...btnStyle}}
                    onClick={() => this.scrollToSection('EserviceDescriptionPanel')}
                    title='Kliknij, aby wrócić do instrukcji tworzenia e-usługi.'
                  >
                    Wróć do instrukcji
                  </button>
              </div>
            </div>
          </GrayPanel>
          : null
        }

        {this.state.showModal ? this.confirmModal() : null}
        {this.state.showDeleteModal ? this.deleteModal() : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </Grid>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices,
});

const mapDispatch = {
};

export default withStyles(styles)(connect(mapState, mapDispatch)(ServiceCreator));



// WEBPACK FOOTER //
// src/routes/admin/service_creator/ServicesCreator.js